import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROPERTY_OCCUPANCY_LIST_API } from "./apiRoutes";

interface UseGetPropertyOccupancyListProps {
  propertyId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyOccupancyList = async (propertyId: string) =>
  await axiosAuth.get(`${PROPERTY_OCCUPANCY_LIST_API(propertyId)}`);

const useGetPropertyOccupancyList = ({
  propertyId,
  queryParams,
}: UseGetPropertyOccupancyListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["propertyOccupancyList", propertyId],
    queryFn: () => getPropertyOccupancyList(propertyId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyOccupancyList;
